import { BaseTransitionCardComponent } from '../../../../../../coverpath-common/angular/components/account-center/transition-card/base-transition-card.component';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
    ToastService,
} from '../../../../../../coverpath-common/angular/components/overlays/toaster/toast-service.service';
import { AmorphicService } from '../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { AccountCenterService } from '../../../../../../coverpath-common/angular/services/account-center/account-center.service';
import { WindowService } from "../../../../../../common/angular-shared/services/window/window.service";

@Component({
    moduleId: module.id,
    selector: 'transition-card',
    templateUrl: './transition-card.component.html'
})
export class TransitionCardComponent extends BaseTransitionCardComponent {

    policyNumber: string = '';

    constructor(
        amorphicService: AmorphicService,
        accountCenterService: AccountCenterService,
        windowService: WindowService, router: Router,
        protected toastService: ToastService
    ) {
        super(amorphicService, accountCenterService, windowService, router, toastService);
        this.contactEmail = `<a href="mailto:SupportDirectTerm@massmutual.com" target="_blank">SupportDirectTerm@massmutual.com</a>`;
        this.contactNumber = `<a href="tel:1-844-611-1027">1-844-611-1027</a>`;
        this.policyNumber = accountCenterService.primaryPolicy.policyNumber;
    }
}
